import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';

// DS
import {
  Col,
  Row,
  VertTypography,
  VertButton,
  VertAccordion,
  VertLoading,
  Divider,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Checkout/CheckoutSummaryStyles.less';

// UTILS
import { maskEmails } from 'Utils/maskFormat';
import { pointsMask } from 'Utils/commons/points';
import CheckoutDifal from './components/CheckoutDifal';
import ynToBool from 'Utils/ynToBool';
import { currencyMask } from 'Utils/commons/mask';
import { setTotalCart } from 'redux/Reducers/Shipping/ShippingSlice';
import { useCheckoutProvider } from '../CheckoutProvider';

// CHECKOUT SUMMARY COMPONENT
const CheckoutSummary = ({
  hasError,
  hasItemsVirtualVoucher,
  isLoading,
  isValid=false,
  cashSelected,
  setCreateOrderActive,
}) => {
  /* Hooks */
  const Catalog = useSelector(({ Catalog: data }) => data);
  const dispatch = useDispatch();
  const Participants = useSelector(({ Participants: data }) => data);
  const itemsCartReducer = useSelector(({ Cart: data }) => data);
  const { cart, coupon } = itemsCartReducer;
  const totalDiscount = coupon?.discountValue || 0;

  const { isValidCheckout } = useSelector((state) => state.DifalSlice);
  const CreatePurchase = useSelector(({ CreatePurchase: data }) => data);

  const ShippingCart = useSelector(({ Shipping: data }) => data);

  const { errorAddressCheckout, errorPhoneNumber } = useSelector(
    (state) => state.ShippingSlice
  );

  const { usedPoints } = useCheckoutProvider();

  const isErrorShipping = ShippingCart?.hasError;

  /* Vars */
  const email = Participants?.email?.value || '';
  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;
  const cartItems = cart?.items || [];
  const totalItemsQdt = cartItems.length;
  const totalItemsValue = cart.price;
  const { value } = ShippingCart;
  const totalRescue = (cart.price || 0) + (value.total || 0) || 0;
  const totalShipping = value?.total;
  const isShippingFree = totalShipping === 0;
  const waitLoading = isLoading;
  const totalCartValue = totalShipping + totalItemsValue - totalDiscount;
  const formateTotalItemsValue = pointsMask(
    totalItemsValue,
    decimalPlaces,
    pointsName
  );
  const formattedTotalValue = pointsMask(
    totalCartValue,
    decimalPlaces,
    pointsName
  );
  const formattedTotalShipping = pointsMask(
    totalShipping,
    decimalPlaces,
    pointsName
  );

  const formatedTotalRescue = pointsMask(
    totalRescue,
    decimalPlaces,
    pointsName
  );

  let createPurchaseIsLoading = CreatePurchase?.isLoading;


  useEffect(() => {
    if (totalCartValue > 0) {
      dispatch(setTotalCart(totalCartValue));
    }

  }, [totalCartValue])

  /* Utils */
  const summaryContent = (
    <>
      <Divider />
      <Row className="checkout-summary-items" justify="space-between">
        <Col>
          <VertTypography.Paragraph>
            {`Ite${totalItemsQdt > 1 ? 'ns' : 'm'} (${totalItemsQdt})`}
          </VertTypography.Paragraph>
        </Col>
        <Col>
          <VertTypography.Paragraph>
            {formateTotalItemsValue.value} {formateTotalItemsValue.label}
          </VertTypography.Paragraph>
        </Col>
      </Row>
      {!hasError && (
        <Row className="checkout-summary-shipping" justify="space-between"
          style={{ display:  ynToBool(process.env.REACT_APP_HIDE_FREIGHT) ? 'none' : ''}}
        >
          <Col>
            <VertTypography.Paragraph className="label">
              Frete
            </VertTypography.Paragraph>
          </Col>

          <Col>
            <VertTypography.Paragraph
              className={isShippingFree ? 'isFree' : ''}
            >
              {waitLoading && <VertLoading size="small" />}
              {!waitLoading && isShippingFree
                ? 'Grátis'
                : `${formattedTotalShipping.value} ${formattedTotalShipping.label}`}
            </VertTypography.Paragraph>
          </Col>
        </Row>
      )}
      {hasItemsVirtualVoucher && email !== '' && (
        <>
          <Divider />
          <Row className="cart-summary-shipping" justify="space-between">
            <Col>
              <VertTypography.Paragraph className="label">
                E-mail:
              </VertTypography.Paragraph>
            </Col>
            <Col>
              <VertTypography.Paragraph
                aria-label={`E-mail oculto: ${maskEmails(email)}`}
              >
                {maskEmails(email)}
              </VertTypography.Paragraph>
            </Col>
          </Row>
        </>
      )}
      <Divider />
      <Row className="checkout-summary-values" justify="space-between">
        <Col>
          <VertTypography.Paragraph>Total do resgate</VertTypography.Paragraph>
        </Col>
        <Col>
          <VertTypography.Paragraph>
            {formatedTotalRescue?.value} {formatedTotalRescue?.label}
          </VertTypography.Paragraph>
        </Col>
      </Row>
      {cashSelected && (
        <Row className="checkout-summary-values" justify="space-between">
          <Col>
            <VertTypography.Paragraph>
              Pagamento no cartão
            </VertTypography.Paragraph>
          </Col>
          <Col>
            <VertTypography.Paragraph>
              {cashSelected}
            </VertTypography.Paragraph>
          </Col>
        </Row>
      )}

      <Divider />
    </>
  );

  const mobileSummaryContent = (
    <VertAccordion
      className="mobile-checkout-summary"
      label="Resumo do resgate"
      size="default"
      template="marketplace"
    >
      {summaryContent}
    </VertAccordion>
  );

  let disabledButton = true;
  if (ynToBool(process.env.REACT_APP_HAS_DIFAL_VALIDATION)) {
    disabledButton =
      isValidCheckout ||
      isErrorShipping ||
      errorAddressCheckout ||
      errorPhoneNumber;
  } else {
    disabledButton =
      !isValid ||
      createPurchaseIsLoading ||
      isErrorShipping ||
      errorAddressCheckout ||
      errorPhoneNumber;
  }
  /* Renders */
  return (
    <Col className="checkout-summary-wrapper col-12 col-md-auto">
      <MediaQuery minWidth={769}>
        <Row className="checkout-summary-title">
          <Col>
            <VertTypography.Title>Resumo do resgate</VertTypography.Title>
          </Col>
        </Row>
        {summaryContent}
      </MediaQuery>

      <MediaQuery maxWidth={768}>{mobileSummaryContent}</MediaQuery>

      {totalDiscount > 0 && ynToBool(process.env.REACT_APP_HAS_COUPON) && (
        <>
          <Row className="checkout-summary-values" justify="space-between">
            <Col>
              <VertTypography.Paragraph>Desconto</VertTypography.Paragraph>
            </Col>
            <Col>
              <VertTypography.Paragraph className="isBold">
                {`${
                  pointsMask(totalDiscount, decimalPlaces, pointsName).value
                } ${
                  pointsMask(totalDiscount, decimalPlaces, pointsName).label
                }`}
              </VertTypography.Paragraph>
            </Col>
          </Row>
          <Divider />
        </>
      )}

      <Row className="checkout-summary-values" justify="space-between">
        <Col>
          <VertTypography.Paragraph>Total</VertTypography.Paragraph>
        </Col>
        <Col>
          <VertTypography.Paragraph className="isBold">
            {
              totalCartValue == 0
                ? <span className="cart-summary-total-free">Grátis</span>
                : (
                  cashSelected
                    ? <>{`${pointsMask(usedPoints, decimalPlaces, pointsName).value} ${pointsMask(usedPoints, decimalPlaces, pointsName).label}`}</>
                    : <>{formattedTotalValue.value} {formattedTotalValue.label}</>
                )
            }
          </VertTypography.Paragraph>
        </Col>
      </Row>
      {cashSelected && (
        <Row className="checkout-summary-values" justify="end">
          <Col>
            <VertTypography.Paragraph className="isBold">
              + {cashSelected}
            </VertTypography.Paragraph>
          </Col>
        </Row>
      )}
      <Divider />
      {ynToBool(process.env.REACT_APP_HAS_DIFAL_VALIDATION) && (
        <CheckoutDifal disabledDifal={!isValid} />
      )}
      <Col className="checkout-summary-button">
        <VertButton
          className={`${!isValid && 'disabled-button'} w-100`}
          onClick={() => setCreateOrderActive({ active: true })}
          type="detached"
          disabled={disabledButton}
          loading={createPurchaseIsLoading}
        >
          Finalizar resgate
        </VertButton>
      </Col>
    </Col>
  );
};

CheckoutSummary.propTypes = {
  isValid: PropTypes.bool,
  installments: PropTypes.number,
  installmentValue: PropTypes.number,
  pointsValue: PropTypes.string,
  pointsSelected: PropTypes.string,
  cashSelected: PropTypes.string,
  setCreateOrderActive: PropTypes.func,
};

export default CheckoutSummary;
